import { Box, Flex, Text } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";

const Progress = (props) => {
  const { step } = props;
  const { t } = useI18n();
  const { isMobile } = useMedia();
  return (
    <Box width={"100%"}>
      <Flex justifyContent={"center"}>
        <Box>
          <Flex justifyContent={"center"} w="120px">
            <Box bg="blue.100" w="8px" h="8px" borderRadius={"8px"}></Box>
          </Flex>
          <Flex justifyContent={"center"} w="100px">
            <Text fontSize="14px" color="t.100" mt="18px">
              {t("KIIMnxhTdJBhZfaEMP")}
            </Text>
          </Flex>
        </Box>
        <Box
          w="70px"
          h="2px"
          bg={step > 1 ? "blue.100" : "#E3E4F1"}
          ml="-30px"
          mt="3px"
        ></Box>
        <Box ml="-30px">
          <Flex justifyContent={"center"} w="120px">
            <Box
              bg={step > 1 ? "blue.100" : "#E3E4F1"}
              w="8px"
              h="8px"
              borderRadius={"8px"}
            ></Box>
          </Flex>
          <Flex justifyContent={"center"}>
            <Text fontSize="14px" color="t.100" mt="18px" w="100px">
              {t("hAacNWPacMHaAAaOw")}
            </Text>
          </Flex>
        </Box>
        <Box
          w="60px"
          h="2px"
          bg={step > 2 ? "blue.100" : "#E3E4F1"}
          ml="-30px"
          mt="3px"
        ></Box>
        <Box ml="-30px">
          <Flex justifyContent={"center"}>
            <Box
              bg={step > 2 ? "blue.100" : "#E3E4F1"}
              w="8px"
              h="8px"
              borderRadius={"8px"}
            ></Box>
          </Flex>
          <Flex justifyContent={"center"} w="130px">
            <Text
              fontSize="14px"
              color="t.100"
              mt="18px"
              position={"relative"}
              left={isMobile && "30px"}
            >
              {t("aCtajuQWKCQNkeKgtwLb")}
            </Text>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default Progress;
